import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { AppConfigService } from "./app/core/services/app-config.service";
import "zone.js/dist/zone"; //MSAL v2
import * as CryptoJS from 'crypto-js';
export let decrypted = false;

if (environment.production) {
  enableProdMode();
}

function bootstrapApp(): void {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
}

document.addEventListener("DOMContentLoaded", () => {
  // We bootstraping app from browser, we need fetch config.json.
  fetch(AppConfigService.configPath)
    .then((response) => {
      return response.json();
    })
    .then((jsonData) => {
      sessionStorage[AppConfigService.configPath] = JSON.stringify(jsonData);
      bootstrapApp();
    })
    .catch((err) => {
      console.warn("caught when bootstrapping app");
      console.error(err);
    });
});

// document.addEventListener('DOMContentLoaded', () => {
//   // We bootstraping app from browser, we need fetch config.json.
//   fetch(AppConfigService.configPath)
//     .then((response) => {
//       return response.json();
//     }).then((jsonData) => {
//       const key = CryptoJS.enc.Utf8.parse("EncryptionKey123");
//       const iv = CryptoJS.enc.Utf8.parse("InitialVector678");
//       const decryptValue = CryptoJS.AES.decrypt(jsonData.msal.auth.clientId,key,{iv:iv}).toString(CryptoJS.enc.Latin1);
//       jsonData.msal.auth.clientId = decryptValue;
      
//       sessionStorage[AppConfigService.configPath] = JSON.stringify(jsonData);
//       decrypted = true;
//       bootstrapApp();
//     }).catch((err) => {
//       console.warn('caught when bootstrapping app');
//       console.error(err);
//     });
// });
